import {AutogenLayoutCarrierInsControl} from "./autogen/AutogenLayoutCarrierInsControl";

export class HighwayOnboardingPanel extends AutogenLayoutCarrierInsControl {

}
